import { Menu } from '@blueprintjs/core';
import { ContextMenu2ContentProps } from '@blueprintjs/popover2';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import { MultiCalendarSelectionType } from '../MultiCalendar';
import { ToolboxToolParts } from './ToolboxParts';
import { WithTranslateProps } from '../../WithTranslate';
import { Button } from 'antd';

interface CalendarContextMenuProps extends WithTranslateProps {
  selectedType: MultiCalendarSelectionType | undefined;
  onTypeClicked: (MultiCalendarSelectionType) => void;
  blackPointHolidayCount?: number;
  blackPointHolidayMax?: number;
  isSecretariat?: boolean;
  onClose: () => void;
  onTransfertDuty?: () => void;
}

export const ToolboxToolsMenu = (props: CalendarContextMenuProps & ContextMenu2ContentProps) => {
  return (
    <Menu
      id={'contexMenu'}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        borderRadius: '5px',
        borderColor: 'black',
        borderWidth: '2px',
        borderStyle: 'solid',
      }}
    >
      <ToolboxToolParts
        id={'bpHoliday1'}
        selectedType={props.selectedType}
        onTypeClicked={props.onTypeClicked}
        translate={props.translate}
        blackPointHolidayCount={props.blackPointHolidayCount}
        blackPointHolidayMax={props.blackPointHolidayMax}
        isSecretariat={props.isSecretariat}
        style={{ margin: '5px', display: 'flex' }}
        hideTitle
        onTransfertDuty={props.onTransfertDuty}
      />
      <Button onClick={props.onClose} icon={IconNames.CROSS} size="small" />
    </Menu>
  );
};
